import React from "react";
import BackButton from "../BackButton/BackButton";
import { Typography } from "@material-ui/core";

const PageHeader = ({
  hasBack = true,
  title,
  onBack,
  subtitle,
  size = "small",
}) => {
  return (
    <div className="flex items-start gap-6">
      {hasBack ? <BackButton onClick={onBack} /> : null}
      <div>
        {size === "large" ? (
          <h1 className="font-bold text-[30px] leading-[36px] text-[#101828] my-0 tracking-[0.3955px]">
            {title}
          </h1>
        ) : (
          <Typography
            style={{ fontSize: "20px", display: "inlineblock" }}
            variant="subtitle2"
          >
            {title}
          </Typography>
        )}
        {subtitle ? (
          <span
            className={
              size === "large"
                ? "text-[16px] leading-[24px] text-[#4a5565] tracking-[-0.3125px]"
                : "text-14 text-gray-500"
            }
          >
            {subtitle}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default PageHeader;
